import http from './httpRequest.js'
import fileDownload from "js-file-download";
import moment from "moment/moment";
import element from 'element-ui';

export default {
  get: async (url, param = {}) => {
    return await http({
      url: http.adornUrl(url),
      method: 'get',
      params: http.adornParams(param)
    }).then(({data}) => {
      if (data.code === 0) {
        return data.data
      } else {
        return null
      }
    }).catch(() => {
      return null
    })
  },
  post: async (url, data = {}) => {
    return await http({
      url: http.adornUrl(url),
      method: 'post',
      data: http.adornData(data)
    }).then(({data}) => {
      if (data.code === 0) {
        return data.data
      } else {
        return null
      }
    }).catch(() => {
      return null
    })
  },
  downloadFile: async (url, data = {}) => {
    return await http({
      url: http.adornUrl(url),
      method: 'post',
      responseType: 'blob',
      data: http.adornData(data)
    }).then(({data}) => {
        if (data && data.code === undefined) {
          return data
        } else {
          return null
        }
    }).catch(() => {
      return null
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/httpUtil.js